import { render, staticRenderFns } from "./BasicView.vue?vue&type=template&id=e6ad7fe8&scoped=true&"
import script from "./BasicView.vue?vue&type=script&lang=js&"
export * from "./BasicView.vue?vue&type=script&lang=js&"
import style0 from "./BasicView.vue?vue&type=style&index=0&id=e6ad7fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ad7fe8",
  null
  
)

export default component.exports